import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { IMAGES, RECIPE_CATEGORIES } from "@/data/content";
import { scrollToSection } from "@/App";

export default function Recipes() {
  return (
    <section className="py-24 sm:py-32 bg-ivory" data-testid="recipes-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <div>
            <SectionHeading
              align="left"
              eyebrow="Recipe Library"
              title="Healthy Eating Shouldn't Be Boring."
              sub="Every coaching pathway includes access to a growing library of practical, healthy recipes — designed to make eating well easier and more enjoyable."
            />
            <Reveal className="-mt-8">
              <div className="flex items-end gap-4 mb-8">
                <motion.p
                  initial={{ opacity: 0, scale: 0.85 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                  className="font-serif text-7xl sm:text-8xl text-forest leading-none"
                  data-testid="recipe-count"
                >
                  150<span className="text-gold">+</span>
                </motion.p>
                <p className="text-xs uppercase tracking-[0.25em] font-bold text-inkmuted pb-3">
                  Healthy
                  <br />
                  Recipes
                </p>
              </div>
              <div className="flex flex-wrap gap-2.5 mb-9">
                {RECIPE_CATEGORIES.map((c, i) => (
                  <span
                    key={c}
                    data-testid={`recipe-category-${i}`}
                    className="px-4 py-2 rounded-full bg-cardbg border border-botanical/15 text-sm font-semibold text-botanical hover:bg-sagesurface transition-colors cursor-default"
                  >
                    {c}
                  </span>
                ))}
              </div>
              <button
                onClick={() => scrollToSection("programs")}
                data-testid="recipes-explore-coaching-button"
                className="inline-flex items-center gap-2 text-sm font-bold tracking-wide text-forest hover:text-sage transition-colors group"
              >
                EXPLORE COACHING
                <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
              </button>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <motion.div
              whileHover={{ scale: 1.015 }}
              transition={{ duration: 0.5 }}
              className="relative overflow-hidden rounded-[2.5rem] rounded-tr-[8rem] border border-gold/30 shadow-hover"
            >
              <img
                src={IMAGES.thali}
                alt="A wholesome, colourful Indian meal with fresh ingredients"
                className="w-full aspect-[4/5] object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-forest/40 to-transparent" />
            </motion.div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
